const state = {
  contents: null,
};

const mutations = {
  setContents(state, contents) {
    state.contents = contents;
  },
};

const actions = {
  setContents({ commit }, contents) {
    commit('setContents', contents);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
